"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchBlob = void 0;
const react_1 = require("react");
const useFetchBlob = (fetchBlob, downloadName) => {
    const [blobUrl, setBlobUrl] = (0, react_1.useState)(undefined);
    const [isRequested, setIsRequested] = (0, react_1.useState)(false);
    const downloadFileNameRef = (0, react_1.useRef)(downloadName);
    const handleFetchBlob = async () => {
        if (!fetchBlob)
            return;
        const response = await fetchBlob();
        const blob = response instanceof Blob ? response : response.blob;
        if (!(response instanceof Blob)) {
            downloadFileNameRef.current = response.filename;
        }
        const blobRefUrl = window.URL.createObjectURL(blob);
        console.log("generated blob URL: ", blobRefUrl);
        setBlobUrl(blobRefUrl);
    };
    (0, react_1.useEffect)(() => {
        return () => {
            if (blobUrl)
                window.URL.revokeObjectURL(blobUrl);
        };
    }, [blobUrl]);
    (0, react_1.useEffect)(() => {
        if (blobUrl && isRequested) {
            openBlobUrl(blobUrl);
            //window.open(blobUrl, "_blank");
            setIsRequested(false);
        }
    }, [blobUrl, isRequested]);
    const openBlobUrl = (url) => {
        const link = document.createElement('a');
        link.target = "_blank";
        link.href = url;
        if (downloadFileNameRef.current) {
            link.setAttribute('download', downloadFileNameRef.current);
        }
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
    };
    const requestOpen = () => {
        if (!blobUrl) {
            (async () => {
                await handleFetchBlob();
            })();
        }
        setIsRequested(true);
    };
    const handleAnchorClick = (e) => {
        e.preventDefault();
        requestOpen();
    };
    return {
        requestOpen,
        isLoading: isRequested && !blobUrl,
        handleAnchorClick
    };
};
exports.useFetchBlob = useFetchBlob;
